<template>
    <div>
        <SkeletonStepsSkeleton v-if="skeleton" />
        <client-only>

            <div class="steps_block for_desktop" v-if="!skeleton">
                <div class="steps_box" :class="{ 'active': stepItem.isComplete }" v-for="( stepItem, key) in finalStepsObject" :key="stepItem.id">
                    <div class="inner_box" :class="{ 'active': stepItem.isComplete }">
                        <div class="inner_box_sn">{{ key+1 }}</div>
                    
                        <!-- --if setting/diamond is selected -- -->
                        <div class="inner_box_product" v-if="stepItem.product !== null">
                            <h3>{{ stepItem.title }}</h3>
                            <h5 class="mb-0">
                                <span v-if="moduleSubType === 'earring' && stepItem.product.page === 'diamond'" class="prod_name">{{ stepItem.product.name }} - {{ stepItem.product.price }} &nbsp;</span> 
                                <span v-else class="prod_name">{{ stepItem.product.name }} - {{ stepItem.product.variant }} - {{ stepItem.product.price }} &nbsp;</span> 
                                <span class="link_cta" @click="productUrl(stepItem.product.page)">View</span>  &nbsp;
                                <span class="link_cta" @click="changeProduct(stepItem.product.page)">Change</span>
                            </h5>  
                        </div>

                        <!-- --if setting/diamond is not selected but on PDP page-- -->
                        <div class="inner_box_product" v-else-if="stepItem.defaultProduct !== null">
                            <h3>{{ stepItem.title }}</h3>
                            <h5 class="mb-0">
                                <span v-if="moduleSubType === 'earring' && stepItem.defaultProduct.page === 'diamond'" class="prod_name">{{ stepItem.defaultProduct.name }} - {{ stepItem.defaultProduct.price }} </span>
                                <span v-else class="prod_name">{{ stepItem.defaultProduct.name }} - {{ stepItem.defaultProduct.variant }} - {{ stepItem.defaultProduct.price }} </span>&nbsp;
                                <span class="link_cta" @click="changeProduct(stepItem.defaultProduct.page)">Change</span>
                            </h5> 
                        </div>

                        <!-- --if setting/diamond is not selected-- -->
                        <div class="inner_box_product" v-else>
                            <h3 class="for_desktop">{{ stepItem.title }}</h3>
                            <h4 class="mb-0">

                                <!-- //show with link  -->
                                    <!-- //for desktop -->
                                <span v-if="stepItem.page === 'setting' && page != 'setting'" class="with_cta for_desktop" @click="productListing(stepItem.page)" >Choose a {{ moduleSubType }} setting</span>
                                
                                <span v-if="stepItem.page === 'diamond' && page != 'diamond'" class="with_cta for_desktop" @click="productListing(stepItem.page)" >Choose a diamond</span>

                                    <!-- //for mobile -->   
                                <span v-if="stepItem.page === 'setting' && page != 'setting'" class="with_cta for_mobile" @click="productListing(stepItem.page)" > Setting</span>

                                <span v-if="stepItem.page === 'diamond' && page != 'diamond'" class="with_cta for_mobile" @click="productListing(stepItem.page)" > Diamond</span>

                                <!-- //show without link -->
                                    <!-- //for desktop -->
                                <span v-if="stepItem.page === 'setting' && page === 'setting'" class="without_cta for_desktop" >Choose a {{ moduleSubType }} setting</span>
                                <span v-if="stepItem.page === 'diamond' && page === 'diamond'" class="without_cta for_desktop" >Choose a diamond</span>
                                    <!-- //for mobile -->
                                <span v-if="stepItem.page === 'setting' && page === 'setting'" class="without_cta for_mobile" >Setting </span>
                                <span v-if="stepItem.page === 'diamond' && page === 'diamond'" class="without_cta for_mobile" >Diamond </span>

                            </h4>  
                        </div>
                        
                        <div class="inner_box_img" v-if="stepItem.product !== null">
                            <div class="img_two" v-if="moduleSubType === 'earring' && stepItem.page === 'diamond'">
                                <img class="mb-1" width="30" height="30" alt="stepper setting image" :src="stepItem.product.image[0]">
                                <img  width="30" height="30" alt="stepper setting image" :src="stepItem.product.image[1]">
                            </div>
                            <img v-else width="50" height="50" alt="stepper setting image" :src="stepItem.product.image">
                        </div>
                        
                        <div class="inner_box_img" v-else>
                            <SvgStepsSvg v-if="stepItem.page === 'setting'" :type="moduleSubType+'_setting'" />
                            <SvgStepsSvg v-if="stepItem.page === 'diamond'" :type="moduleSubType+'_diamond'" />
                        </div>
                    </div>
                </div>

                <div class="steps_box" :class="{ 'active': isComplete }">
                    <div class="inner_box" :class="{ 'active': isComplete }">
                        <div class="inner_box_sn">3</div>     

                        <div class="inner_box_product" v-if="!isComplete && isItemComplete">
                            <h3 class="1">Complete</h3>
                            <h5 class="mb-0">
                                <span class="link_cta" @click="completeUrl">View</span>
                            </h5>  
                        </div>

                        <div class="inner_box_product" v-else-if="!isComplete && !isItemComplete">
                            <h3 class="for_mobile mb-0">Complete</h3>
                            <h3 class="for_desktop">Complete</h3>
                            <h5 class="mb-0 for_desktop">
                                <span v-if="moduleSubType == 'ring'">Select a ring size</span>
                                <span v-if="moduleSubType == 'pendant'">Select a chain length</span>
                                <span v-if="moduleSubType == 'earring'">Select a back type</span>
                            </h5>   
                        </div>
                        <div class="inner_box_product" v-else-if="isItemComplete && isComplete">
                            <h3 class="for_desktop">Complete</h3>
                            <h3 class="for_mobile mb-0 3">Complete</h3>
                            <h5 class="mb-0 for_desktop">
                                <span v-if="moduleSubType == 'ring'">Select a ring size</span>
                                <span v-if="moduleSubType == 'pendant'">Select a chain length</span>
                                <span v-if="moduleSubType == 'earring'">Select a back type</span>
                            </h5>   
                        </div>

                        <div class="inner_box_img">
                            <img alt="stepper complete image" v-if="isItemComplete" width="70" height="70" :src="setting.image">
                            <SvgStepsSvg v-else :type="moduleSubType+'_complete'" />
                        </div>
                    </div>
                </div>
            </div>
        
            <div class="steps_block for_mobile" v-if="!skeleton">
                <div class="steps_box" :class="{ 'active': stepItem.isComplete }" 
                v-for="( stepItem, key) in finalStepsObject" :key="stepItem.id" @click="openModal(stepItem)" >
                    <div class="inner_box" :class="{ 'active': stepItem.isComplete }">
                        <div class="inner_box_sn">{{ key+1 }}</div>
                    
                        <div class="inner_box_product">
                            <h3 class="m-0">{{ stepItem.title }}</h3>
                        </div>
                        
                        <div class="inner_box_img"></div>
                    </div>
                </div>

                <div class="steps_box" :class="{ 'active': isComplete }"  @click="goToComplete()">
                    <div class="inner_box" :class="{ 'active': isComplete }">
                        <div class="inner_box_sn">3</div>     
                        <div class="inner_box_product">
                            <h3 class="m-0">Complete</h3>
                        </div>
                        <div class="inner_box_img"></div>
                    </div>
                </div>
            </div>
            
            <div class="no_overlay" @click="hideModal" :class="{'setting_overlay': open_modal === 'setting', 'diamond_overlay': open_modal === 'diamond'}"></div>
            <div class="step_modal for_mobile">
                <div v-if="settingDataObject.product">
                    <CyoStepsModalSetting
                        class="closed_setting"
                        :class="{'opened_setting' : open_modal === 'setting'}"
                        :data="settingDataObject" 
                        @closePopup="closePopup"
                        @productUrl="productUrl"
                        @changeProduct="changeProduct"
                    />
                </div>
                <div v-if="diamondDataObject.product">
                    <CyoStepsModalDiamond
                        class="closed_setting diamond"
                        :class="{'opened_setting' : open_modal === 'diamond'}"
                        :data="diamondDataObject" 
                        @closePopup="closePopup"
                        @productUrl="productUrl"
                        @changeProduct="changeProduct"
                    />
                </div>
            </div>

        </client-only>
    </div>
</template>

<script setup>

    import { cyodetailStore }  from '@/stores/cyodetail/cyodetail';
    import { cyoStore }  from '@/stores/cyo/cyo';

    const storeDetail = cyodetailStore()
    const storeCyo = cyoStore();

    const route = useRoute();
    const router = useRouter();
    const localePath = useLocalePath();

    const moduleType = route.meta.moduleType

    const { $country, $formatPrice, $toast } = useNuxtApp()

    const props = defineProps(['page', 'moduleSubType','item'])

    const skeleton = ref(true)
    const start_with = ref('')

    const open_modal = ref(null)

    function hideModal(){
        open_modal.value = null
        document.body.classList.remove('filter_open');
    }

    
    function openModal(data){
        if(data.product == null){
            window.scrollTo({ top: 0, behavior: 'smooth' });
            document.body.classList.remove('filter_open');
        }
        if(data.product !== null){
            open_modal.value = data.page
            document.body.classList.add('filter_open');
        }else{
            productListing(data.page)
        }
        
        // document.body.classList.add('filter_open');
    }

    function goToComplete(){
        if(!isComplete.value && isItemComplete.value){
            completeUrl()
        }else{
            return
        }
    }

    function closePopup(){
        open_modal.value = null
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.body.classList.remove('filter_open');
    }

    // get setting data
    const setting = computed(() => {
        return storeCyo.getSetting(props.moduleSubType)
    })
    const defaultSetting = computed(() => {
        const setting = storeDetail.getSettingDetail(props.moduleSubType )
        if (setting && props.page == 'setting' ) {
            const metal = setting.metals.find( cv => cv.selected === 1 )
            const data = { name: setting.short_name, price:metal.price, variant: metal.label }
            return data
        }
        return null
    })

    // get diamond data
    const diamond = computed(() => {
        return storeCyo.getDiamond(props.moduleSubType)
    })
    const defaultDiamond = computed(() => {
        if (props.item && props.page == 'diamond') {
            return props.item
        }
        return null
    })
    // create setting object for steps
    const settingDataObject = computed(() => {

        const isListingPage =  route.name.includes( "cyo-setting-list" )

        let obj = {
            title: 'Setting',
            page: 'setting',
            product: null,
            defaultProduct: null,
            noProduct: false,
            isComplete: props.page === 'setting' ? true : false
        }

        if(setting.value){
            const d = {}
            d.id = setting.value.metal.id
            d.name = setting.value.short_name
            d.variant = setting.value.metal.label
            d.price = $formatPrice(setting.value.metal.price)
            d.image = setting.value.image
            d.page = 'setting'

            obj.product = d
            return obj
        }

        else if(defaultSetting.value && !isListingPage ){
            const d = {}
            d.name = defaultSetting.value.name
            d.variant = defaultSetting.value.variant
            d.price = $formatPrice(defaultSetting.value.price)
            d.page = 'setting'
            obj.defaultProduct = d
            return obj
        }

        else{
            obj.noProduct = true
            return obj
        }
        
    })
   

    // create diamond object for steps
    const diamondDataObject = computed(() => {


        const obj = {
            title: 'Diamond',
            page: 'diamond',
            product: null,
            defaultProduct: null,
            noProduct: false,
            isComplete: props.page === 'diamond' ? true : false
        }

        if(diamond.value){

            const d = {}
            d.name = diamond.value.title
            
            if(props.moduleSubType === 'earring'){
                d.variant = ''
                d.image = [diamond.value.diamond_image_one, diamond.value.diamond_image_two]
                d.price = $formatPrice(diamond.value.price_total)
            }else{
                d.variant = `${diamond.value.color} | ${diamond.value.clarity}`
                d.image = diamond.value.diamond_thumb_image
                d.price = $formatPrice(diamond.value.price)
            }

            d.page = 'diamond'

            obj.product = d
            return obj
        }

        if(defaultDiamond.value){

            const d = {}
            d.name = defaultDiamond.value.title
            
            d.image = defaultDiamond.value.diamond_thumb_image
            if(props.moduleSubType === 'earring'){
                d.variant = ''
                d.image = [defaultDiamond.value.diamond_image_one, defaultDiamond.value.diamond_image_two]
                d.price = $formatPrice(defaultDiamond.value.price_total)
            }else{
                d.variant = `${defaultDiamond.value.color} | ${defaultDiamond.value.clarity}`
                d.image = defaultDiamond.value.diamond_thumb_image
                d.price = $formatPrice(defaultDiamond.value.price)
            }
            d.page = 'diamond'

            obj.defaultProduct = d
            return obj
        }

        obj.noProduct = true
        return obj
        
    })

    //create main object to loop in steps with order 
    const finalStepsObject = computed(() => {
        const obct = []
        if(start_with.value === 'setting'){
            obct.push(settingDataObject.value)
            obct.push(diamondDataObject.value)
            return obct
        }
        // if(this.start_with === 'diamond'){
        //     obct.push(this.diamondDataObject)
        //     obct.push(this.settingDataObject)
        // }

        // if(this.start_with === 'diamond'){
            obct.push(diamondDataObject.value)
            obct.push(settingDataObject.value)
        // }

        return obct
    })

     //for complete page
    const isComplete = computed(() => {
        return props.page === 'complete' ? true : false
    }) 

    const isItemComplete = computed(() => {
        return diamond.value !== null && setting.value !== null
    })

    function changeProduct(type){
        open_modal.value = null
        if(type === 'setting'){
           
            productListing(type) 
            storeCyo.unsetSetting(props.moduleSubType)
        }
        if(type === 'diamond'){
            productListing(type) 
            storeCyo.unsetDiamond(props.moduleSubType)
        }
    }


    async function productListing(type){
        
        if(type === 'setting'){
           
            const listFilters = storeCyo.getListingUrl( {moduleSubType:props.moduleSubType, page:'setting'} )
            
            const route = router.resolve( localePath( {name: 'cyo-setting-list-'+props.moduleSubType}) )

            if (route.href !== undefined && listFilters) {

                return router.push(  route.href+"?"+listFilters  )
                
            }

            return router.push( localePath( {name: 'cyo-setting-list-'+props.moduleSubType}) );  
            
        }
        if(type === 'diamond'){

            const listFilters = storeCyo.getListingUrl( {moduleSubType:props.moduleSubType, page:'diamond'} )
           
            const route = router.resolve( localePath( {name: 'cyo-diamond-list-'+props.moduleSubType}) )
          
            if (route.href !== undefined && listFilters) {
                return router.push( route.href+"?"+listFilters ) 
                
            } 
            
            return router.push(localePath( {name: 'cyo-diamond-list-'+props.moduleSubType} )); 
             
        }
    }
   
    function productUrl(type){
        if(type === 'setting'){
            router.push(localePath( { 
                name:'cyo-setting-detail-'+props.moduleSubType, 
                params:{ slug: storeCyo.getSetting(props.moduleSubType).metal.slug } 
            }));
        }
        if(type === 'diamond'){
            router.push(localePath({
                name: 'cyo-diamond-detail-'+props.moduleSubType, 
                params:{slug: storeCyo.getDiamond( props.moduleSubType ).slug }
            }));
        }
    }

    function completeUrl(){
        if (setting.value && diamond.value) {
            router.push( localePath( {name: 'cyo-complete-'+props.moduleSubType, query:{ sid: setting.value.metal.id, did: diamond.value.id }}));
        }
    }

 

    onMounted(() =>{
        skeleton.value = false

    })
    
    onBeforeMount(() =>{
        start_with.value = storeCyo.getStartWith(props.moduleSubType )
        if(!start_with.value){
            start_with.value = props.page
        }
    })
        
</script>

<style scoped>
.step_modal.closed_setting {
    bottom: -100%;
    transition: 1s;
    height: 0;
}

.step_modal.closed_setting.opened_setting {
    bottom: 0;
    transition: 0.6s;
    height: 440px;
    max-height: 85vh;
}

.step_modal.closed_setting.diamond.opened_setting{
    height: 410px;
}

.no_overlay{
    position: fixed;
    bottom: -100%;
    /* transition: 0.7s; */
    left: 0;
    content: '';
    width: 100%;
    height: 0;
    background: #00000063;
    z-index: 99;
}
.setting_overlay, .diamond_overlay {
    bottom: 0;
    height: 100%;

    /* transition: 0.1s; */
    transition-delay: 0.1s;
}
.steps_block {
    display: flex;
    align-items: center;
    position: relative;
    height: 80px;
    width: 100%;
}

.steps_box {
    min-height: 80px;
    position: absolute;
    padding: 1px;
}
.steps_box.active{
    background: #fff !important;
    width: 35% !important;
    z-index: 1;
}
/* -------------------------- */

.steps_box:nth-child(1) {
    clip-path: polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%);
    width: 34.70%;
    left: 0;
    transform: translate(0%, 0);
    background: #ccc;
    border-radius: 8px 0 0 8px;
}




.steps_box:nth-child(1) .inner_box {
    background: #fff;
    height: 80px;
    clip-path: polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%);
    position: relative;
    padding-right: 20px;
    border-radius: 8px 0 0 8px;
    
}
.steps_box:nth-child(1) .inner_box.active {
    background: var(--green);
    height: 82px;
    border-radius: 8px 0 0 8px;
}
.steps_box:nth-child(1) .inner_box.active:before {
    position: absolute;
    content: "";
    clip-path: polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%);
    background: #fff;
    height: calc(100% - 2px);
    width: calc(100% - 2px);
    left: 1px;
    top: 1px;
    z-index: -1;
    border-radius: 8px 0 0 8px;
}

/* ------------------------------------------ */

.steps_box:nth-child(2) {
    clip-path: polygon(95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%, 0% 0%);
    width: 34.70%;
    left: 50%;
    transform: translate(-50%, 0);
    background: #ccc;
}
.steps_box:nth-child(2) .inner_box {
    background: #fff;
    height: 80px;
    clip-path: polygon(95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%, 0% 0%);
    margin-left: 0.5px;
    position: relative;
    padding: 0 20px;
}
.steps_box:nth-child(2) .inner_box.active {
    background: var(--green);
    height: 82px;
    margin-left: -0.5px;
}
.steps_box:nth-child(2) .inner_box.active:before {
    position: absolute;
    content: "";
    clip-path: polygon(95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%, 0% 0%);
    background: #fff;
    height: calc(100% - 2px);
    width: calc(100% - 3px);
    left: 2px;
    top: 1px;
    z-index: -1;
}

/* ----------------------------------- */


.steps_box:nth-child(3) {
    clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 5% 50%, 0% 0%);
    width: 34.70%;
    left: 100%;
    transform: translate(-100%, 0);
    background: #ccc;
    border-radius: 0 8px 8px 0;
}
.steps_box:nth-child(3) .inner_box {
    background: #fff;
    height: 80px;
    clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 5% 50%, 0% 0%);
    margin-left: 0.5px;
    position: relative;
    padding:0 20px;
    border-radius: 0 8px 8px 0;
}
.steps_box:nth-child(3) .inner_box.active {
    background: var(--green);
    margin-left: -0.5px;
    height: 82px;
    border-radius: 0 8px 8px 0;
}
.steps_box:nth-child(3) .inner_box.active:before {
    position: absolute;
    content: "";
    clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 5% 50%, 0% 0%);
    background: #fff;
    height: calc(100% - 2px);
    width: calc(100% - 3px);
    left: 2px;
    top: 1px;
    z-index: -1;
    border-radius: 0 8px 8px 0;
}


/* steps block for mobile  */
.steps_block.for_mobile{
    border-radius: 0 !important;
}

.steps_block.for_mobile .steps_box{
    border-radius: 0 !important;
}

.steps_block.for_mobile .inner_box{
    border-radius: 0;
}

.steps_block.for_mobile .inner_box.active{
    border-radius: 0;
}

.steps_block.for_mobile .inner_box.active:before{
    border-radius: 0;
}

/* ----------------------------------- */


.inner_box {
    display: flex;
    align-items: center;
}

.inner_box_sn {
    width: 15%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    color: #c4c4c4;
}

.inner_box_product {width: 70%;}

.inner_box_img {
    width: 15%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.inner_box_product h3 {
    font-size: 14px;
    color: #212529;
    font-weight: 600;
    margin-bottom: 4px;
    text-transform: uppercase;
}

.inner_box_product h4 {
    font-size: 14px;
    font-weight: 400;
    text-transform: capitalize;
  
}
.inner_box_product h4 span.with_cta {
    text-decoration: underline;
    cursor: pointer;
}
.inner_box_product h5 {
    font-size: 14px;
    font-weight: 400;
    text-transform: capitalize;
    cursor: pointer;
    line-height: 1.3;
}
.inner_box_product h5 span.prod_name {
    /* color: var(--green);
    font-weight: 600; */
    
}
.inner_box_product h5 span.link_cta {
    text-decoration: underline;
    color: #606060;
}

@media(max-width: 1024px){
    .steps_block {
        height: 100px;
    }
    .steps_box {
        height: 100px;
    }
    .inner_box {
        height: 98px !important;
    }
    .steps_box:nth-child(1) .inner_box.active, .steps_box:nth-child(2) .inner_box.active, .steps_box:nth-child(3) .inner_box.active {
        margin-left: -0.5px;
        height: 100px !important;
    }
    .steps_box:nth-child(1) .inner_box.active:before, 
    .steps_box:nth-child(2) .inner_box.active:before{
        /* width: calc(100% - 4px); */
    }
    .steps_box.active {
        background: #fff !important;
        height: 102px;
        top: -1px;
    }
}


@media(max-width: 992px){

}
@media(max-width: 767px){
    .inner_box_product h5 span.prod_name{
        display: none;
    }
    .inner_box_img {
        display: none;
    }
    .inner_box_sn {
        width: 20%;
        font-size: 22px;
    }

    .inner_box_product {
        width: 80%;
        padding-left: 5px;
        margin-top: 2px;
    }
    .inner_box_product h3 {
        font-size: 12px;
    }
    .inner_box_product h5 span.link_cta{
        font-size: 10px;
    }
   
    .steps_box {
        height: 64px;
        min-height: auto;
    }
    .inner_box {
        height: 62px !important;
    }

    .steps_block {
        height: 64px;
    }

    .steps_box:nth-child(1),
    .steps_box:nth-child(2),
    .steps_box:nth-child(3) {
        width: 36%;
    }
    .steps_box:nth-child(1) {
        clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
    }
    .steps_box:nth-child(1) .inner_box {
        clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
        padding-right: 12px;
    }
    .steps_box:nth-child(1) .inner_box.active:before {
        clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
        /* width: calc(100% - 3px); */
    }



    .steps_box:nth-child(2) {
        clip-path: polygon(90% 0%, 100% 50%, 90% 100%, 0% 100%, 10% 50%, 0% 0%);
    }
    .steps_box:nth-child(2) .inner_box {
        clip-path: polygon(90% 0%, 100% 50%, 90% 100%, 0% 100%, 10% 50%, 0% 0%);
        padding: 0 12px;
    }
    .steps_box:nth-child(2) .inner_box.active:before {
        clip-path: polygon(90% 0%, 100% 50%, 90% 100%, 0% 100%, 10% 50%, 0% 0%);
    }


    .steps_box:nth-child(3) {
        clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 10% 50%, 0% 0%);
    }
    .steps_box:nth-child(3) .inner_box {
        clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 10% 50%, 0% 0%);
        padding: 0 5px 0 12px;
    }
    .steps_box:nth-child(3) .inner_box.active:before {
        clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 10% 50%, 0% 0%);
    }


    .inner_box_product h4 span.with_cta, .inner_box_product h4 span.without_cta{
        font-size: 12px;
    }



    .steps_box:nth-child(1) .inner_box.active, .steps_box:nth-child(2) .inner_box.active, .steps_box:nth-child(3) .inner_box.active {
        height: 64px !important;
    }
    .steps_box.active {
        height: 65px;
        top: -1px;
        width: 36% !important;
    }


    @media(max-width: 512px){
        .steps_block {
            height: 64px;
            margin-left: -10px;
            width: calc( 100% + 20px );
        }
    }
}

/* ---------------popup----------------- */

</style>
